import { Directive, ElementRef, Input, NgModule, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {data as icons} from './icon-data';

@Directive({
    selector: '[icon]',
    standalone: false
})
export class IconDirective implements OnInit, OnChanges {
  public static icons = [
    'arrow-down',
    'external-link',
    'globe',
    'play-circle',
    'question',
    'hinge',
    'menu',
    'user',
    'locked', 'unlocked',
    'chevron',
    'download',
    'search',
    'close',
    'grip-dots',
    'move',
    // next with bg circle
    'twitter', 'facebook', 'flickr', 'linked-in', 'newsletter', 'rss', 'youtube',
    // logos
    'logo-en', 'logo-fr', 'logo-es', 'logo-ru', 'logo-ar', 'logo-zh'
  ] as const;
  public static iconNames() {
    return IconDirective.icons;
  }
  static getIconHTML(icon: keyof typeof icons | undefined){
    return !icon ? '' : ((icons[icon] as string) || '').replace('<svg ', 
    '<svg aria-hidden="true" class="b-icon--as-char" focusable="false" role="img" ');
  }
  @Input() icon!: keyof typeof icons | undefined;
  @Input() circleColor: string = '#fff';

  get iconSVG(): string {
    // inject standard attributes + class
    const i = IconDirective.getIconHTML(this.icon);
    // if circle element present and we hv defined a fill color
    return this.circleColor ? i.replace('<circle ', `<circle fill="${this.circleColor}" `) : i;
  }


  constructor(protected elRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.elRef.nativeElement.innerHTML = this.iconSVG;
  }
  ngOnInit(): void {
    this.elRef.nativeElement.innerHTML = this.iconSVG;
  }
}
export type WipoSVGIcons = typeof IconDirective.icons[number];
@NgModule({
  exports: [IconDirective],
  declarations: [IconDirective]
})
export class IconDirectiveModule { }
